import React, { useState, useEffect } from 'react';
import Login from './pages/Login';
import Blog from './pages/Blog';
import Category from './pages/Category';
import Comments from './pages/Comments';
import ContactMessages from './pages/ContactMessages';
import About from './pages/About';
import Contact from './pages/Contact';
import Media from './pages/Media';
import Social from './pages/Social';
import CustomPages from './pages/CustomPages';
import FAQ from './pages/FAQ';
import Testimonial from './pages/Testimonial';
import Landing from './pages/Landing';
import Users from './pages/Users';
import { Toaster } from 'react-hot-toast';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Badge from '@mui/material/Badge';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import TextField from '@mui/material/TextField';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Divider from '@mui/material/Divider';
import LogoutIcon from '@mui/icons-material/Logout';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ArticleIcon from '@mui/icons-material/Article';
import CategoryIcon from '@mui/icons-material/Category';
import CommentIcon from '@mui/icons-material/Comment';
import InfoIcon from '@mui/icons-material/Info';
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
import PermMediaIcon from '@mui/icons-material/PermMedia';
import ShareIcon from '@mui/icons-material/Share';
import HomeIcon from '@mui/icons-material/Home';
import PagesIcon from '@mui/icons-material/Pages';
import SettingsIcon from '@mui/icons-material/Settings';
import EmailIcon from '@mui/icons-material/Email';
import PeopleIcon from '@mui/icons-material/People';
import LockIcon from '@mui/icons-material/Lock';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import PageEditor from './pages/PageEditor';
import Settings from './pages/Settings';
import axios from 'axios';
import { getApiUrl } from './config';

const menuItems = [
  { key: 'dashboard', label: 'داشبورد', icon: <DashboardIcon /> },
  { key: 'blog', label: 'مدیریت بلاگ', icon: <ArticleIcon /> },
  { key: 'category', label: 'دسته‌بندی‌های بلاگ', icon: <CategoryIcon /> },
  { key: 'comments', label: 'نظرات بلاگ', icon: <CommentIcon /> },
  { key: 'contact-messages', label: 'پیام‌های تماس', icon: <ContactPhoneIcon /> },
  { key: 'users', label: 'مدیریت کاربران', icon: <PeopleIcon /> },
  { key: 'landing', label: 'لندینگ پیج', icon: <HomeIcon /> },
  { key: 'about', label: 'درباره ما', icon: <InfoIcon /> },
  { key: 'contact', label: 'تماس با ما', icon: <ContactPhoneIcon /> },
  { key: 'media', label: 'رسانه‌ها', icon: <PermMediaIcon /> },
  { key: 'social', label: 'شبکه‌های اجتماعی', icon: <ShareIcon /> },
  { key: 'custom-pages', label: 'صفحات سفارشی', icon: <PagesIcon /> },
  { key: 'faq', label: 'سوالات متداول', icon: <InfoIcon /> },
  { key: 'testimonial', label: 'نظرات مشتریان', icon: <InfoIcon /> },
  { key: 'settings', label: 'تنظیمات سایت', icon: <SettingsIcon /> },
];

function MainApp() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [unreadMessagesCount, setUnreadMessagesCount] = useState(0);
  const [posts, setPosts] = useState([]);
  const [comments, setComments] = useState([]);
  const [contactMessages, setContactMessages] = useState([]);
  const [media, setMedia] = useState([]);
  const [changePasswordOpen, setChangePasswordOpen] = useState(false);
  const [passwordData, setPasswordData] = useState({
    newPassword: '',
    confirmPassword: ''
  });
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success'
  });
  const [userMenuAnchor, setUserMenuAnchor] = useState(null);
  const [currentUser, setCurrentUser] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (localStorage.getItem('token')) {
      setIsLoggedIn(true);
      fetchUnreadMessagesCount();
      fetchDashboardData();
      fetchCurrentUser();
      
      // به‌روزرسانی هر 2 دقیقه
      const interval = setInterval(fetchUnreadMessagesCount, 120000);
      
      return () => clearInterval(interval);
    }
  }, []);

  const fetchDashboardData = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) return;


      // دریافت داده‌های مختلف به صورت موازی
      const [postsRes, commentsRes, messagesRes, mediaRes] = await Promise.all([
        axios.get(getApiUrl('/api/blog'), {
          headers: { Authorization: `Bearer ${token}` }
        }),
        axios.get(getApiUrl('/api/comments'), {
          headers: { Authorization: `Bearer ${token}` }
        }),
        axios.get(getApiUrl('/api/contact-messages'), {
          headers: { Authorization: `Bearer ${token}` }
        }),
        axios.get(getApiUrl('/api/media'), {
          headers: { Authorization: `Bearer ${token}` }
        })
      ]);

      const postsCount = (postsRes && postsRes.data && postsRes.data.length) ? postsRes.data.length : 0;
      const commentsCount = (commentsRes && commentsRes.data && commentsRes.data.length) ? commentsRes.data.length : 0;
      const messagesCount = (messagesRes && messagesRes.data && messagesRes.data.length) ? messagesRes.data.length : 0;
      const mediaCount = (mediaRes && mediaRes.data && mediaRes.data.length) ? mediaRes.data.length : 0;

      console.log('Dashboard data received:', {
        posts: postsCount,
        comments: commentsCount,
        messages: messagesCount,
        media: mediaCount
      });

      setPosts(postsRes.data || []);
      setComments(commentsRes.data || []);
      setContactMessages(messagesRes.data || []);
      setMedia(mediaRes.data || []);
    } catch (error) {
      console.error('Error fetching dashboard data:', error);
      // تنظیم مقادیر پیش‌فرض در صورت خطا
      setPosts([]);
      setComments([]);
      setContactMessages([]);
      setMedia([]);
    }
  };

  const fetchUnreadMessagesCount = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) return;
      
      const response = await axios.get(getApiUrl('/api/contact-messages/unread/count'), {
        headers: { Authorization: `Bearer ${token}` }
      });
      setUnreadMessagesCount(response.data.count);
    } catch (error) {
      console.error('Error fetching unread messages count:', error);
    }
  };

  const fetchCurrentUser = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) return;
      
      // از JWT token اطلاعات کاربر را استخراج می‌کنیم
      const payload = JSON.parse(atob(token.split('.')[1]));
      setCurrentUser({ username: payload.username, id: payload.id });
    } catch (error) {
      console.error('Error fetching current user:', error);
    }
  };

  if (!isLoggedIn) {
    return <Login onLogin={() => setIsLoggedIn(true)} />;
  }

  const handleDrawerToggle = () => {
    const newDrawerOpen = !drawerOpen;
    setDrawerOpen(newDrawerOpen);
    
    // Prevent body scroll when drawer is open
    if (newDrawerOpen) {
      document.body.classList.add('drawer-open');
    } else {
      document.body.classList.remove('drawer-open');
    }
  };
  const handleMenuClick = (key) => {
    let path = '/';
    switch (key) {
      case 'dashboard': path = '/'; break;
      case 'blog': path = '/blog'; break;
      case 'category': path = '/category'; break;
      case 'comments': path = '/comments'; break;
      case 'contact-messages': 
        path = '/contact-messages'; 
        // به‌روزرسانی تعداد پیام‌های نخوانده هنگام ورود به صفحه پیام‌ها
        setTimeout(() => fetchUnreadMessagesCount(), 100);
        break;
      case 'users': path = '/users'; break;
      case 'landing': path = '/landing'; break;
      case 'about': path = '/about'; break;
      case 'contact': path = '/contact'; break;
      case 'media': path = '/media'; break;
      case 'social': path = '/social'; break;
      case 'custom-pages': path = '/custom-pages'; break;
      case 'faq': path = '/faq'; break;
      case 'testimonial': path = '/testimonial'; break;
      case 'settings': path = '/settings'; break;
      default: path = '/';
    }
    navigate(path);
    setDrawerOpen(false);
    document.body.classList.remove('drawer-open');
  };

  const showSnackbar = (message, severity = 'success') => {
    setSnackbar({ open: true, message, severity });
  };

  const handlePasswordInputChange = (e) => {
    const { name, value } = e.target;
    setPasswordData(prev => ({ ...prev, [name]: value }));
  };

  const handleChangePasswordSubmit = async (e) => {
    e.preventDefault();
    
    if (passwordData.newPassword !== passwordData.confirmPassword) {
      showSnackbar('رمز عبور جدید و تایید آن مطابقت ندارند', 'error');
      return;
    }

    try {
      const token = localStorage.getItem('token');
      await axios.put(getApiUrl('/api/change-password'), {
        newPassword: passwordData.newPassword
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      showSnackbar('رمز عبور با موفقیت تغییر کرد', 'success');
      setChangePasswordOpen(false);
      setPasswordData({ newPassword: '', confirmPassword: '' });
    } catch (error) {
      console.error('Error changing password:', error);
      showSnackbar(error.response?.data?.error || 'خطا در تغییر رمز عبور', 'error');
    }
  };

  const handleChangePasswordClose = () => {
    setChangePasswordOpen(false);
    setPasswordData({ newPassword: '', confirmPassword: '' });
  };

  const handleUserMenuOpen = (event) => {
    setUserMenuAnchor(event.currentTarget);
  };

  const handleUserMenuClose = () => {
    setUserMenuAnchor(null);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    setIsLoggedIn(false);
    setUserMenuAnchor(null);
  };

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: '#f8fafc', fontFamily: 'Vazir' }}>
      <Toaster position="top-center" reverseOrder={false} />
      
      {/* Desktop Sidebar - Fixed on the right */}
      <Box className="admin-sidebar" sx={{ 
        display: { xs: 'none', md: 'block' },
        background: 'linear-gradient(180deg, #004d34 0%, #004d34 100%)', // Rafi project primary gradient
        boxShadow: '0 0 30px rgba(48, 211, 174, 0.3)',
        borderLeft: '1px solid rgba(255, 255, 255, 0.1)',
      }}>
        <Toolbar sx={{ 
          background: 'rgba(255, 255, 255, 0.1)', 
          backdropFilter: 'blur(10px)',
          borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
        }}>
          <Typography variant="h6" sx={{ 
            color: 'white', 
            fontWeight: 'bold', 
            fontFamily: 'Yekan, Vazir', // Rafi project font priority
            textAlign: 'center',
            width: '100%'
          }}>
            پنل مدیریت
          </Typography>
        </Toolbar>
        <Box sx={{ overflow: 'auto', pt: 2, fontFamily: 'Vazir' }}>
          <List sx={{ fontFamily: 'Vazir', px: 1 }}>
            {menuItems.map((item) => (
              <ListItem key={item.key} disablePadding sx={{ mb: 0.5, fontFamily: 'Vazir' }}>
                <ListItemButton 
                  selected={location.pathname === `/${item.key}`} 
                  onClick={() => handleMenuClick(item.key)}
                  sx={{
                    borderRadius: 3,
                    mx: 0.5,
                    py: 1.5,
                    background: location.pathname === `/${item.key}` 
                      ? 'rgba(255, 255, 255, 0.2)' 
                      : 'transparent',
                    color: location.pathname === `/${item.key}` ? '#fff' : 'rgba(255, 255, 255, 0.8)',
                    '&:hover': { 
                      background: 'rgba(255, 255, 255, 0.15)', 
                      color: '#fff',
                      transform: 'translateX(-4px)',
                    },
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    direction: 'rtl',
                    textAlign: 'right',
                    fontFamily: 'Yekan, Vazir', // Rafi project font priority
                    transition: 'all 0.3s ease',
                    position: 'relative',
                    '&::before': location.pathname === `/${item.key}` ? {
                      content: '""',
                      position: 'absolute',
                      right: 0,
                      top: '50%',
                      transform: 'translateY(-50%)',
                      width: '4px',
                      height: '60%',
                      background: 'rgba(255, 255, 255, 0.8)',
                      borderRadius: '0 4px 4px 0',
                    } : {},
                  }}
                >
                  <ListItemText
                    primary={item.label}
                    sx={{
                      fontFamily: 'Yekan, Vazir', // Rafi project font priority
                      ml: 3,
                      fontWeight: location.pathname === `/${item.key}` ? 'bold' : '500',
                      fontSize: '1rem',
                      width: '100%',
                      '& .MuiListItemText-primary': {
                        textAlign: 'right', // راست‌چین کردن متن
                        direction: 'rtl',
                      },
                    }}
                  />
                  <Box sx={{ 
                    opacity: location.pathname === `/${item.key}` ? 1 : 0.7,
                    transition: 'opacity 0.3s ease',
                  }}>
                  {item.icon}
                  </Box>
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Box>
      </Box>

      {/* Mobile Sidebar */}
      <Drawer
        variant="temporary"
        anchor="left"
        open={drawerOpen}
        onClose={handleDrawerToggle}
        ModalProps={{ 
          keepMounted: true,
          disableScrollLock: true,
        }}
        sx={{
          display: { xs: 'block', md: 'none' },
          zIndex: 1300,
          [`& .MuiDrawer-paper`]: {
            width: 280,
            boxSizing: 'border-box',
            background: 'linear-gradient(180deg, #004d34 0%, #004d34 100%)', // Rafi project primary gradient
            borderLeft: 0,
            borderRight: 0,
            borderRadius: 0,
            boxShadow: '0 0 30px rgba(48, 211, 174, 0.3)',
            p: 0,
            direction: 'rtl',
            textAlign: 'right',
            fontFamily: 'Vazir !important',
            overflow: 'hidden',
            '& .MuiListItemText-root, & .MuiListItemButton-root, & .MuiTypography-root': {
              fontFamily: 'Vazir !important',
            },
          },
          direction: 'rtl',
          '& .MuiBackdrop-root': {
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            backdropFilter: 'blur(4px)',
          },
        }}
      >
        <Toolbar sx={{ 
          background: 'rgba(255, 255, 255, 0.1)', 
          backdropFilter: 'blur(10px)',
          borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
          justifyContent: 'space-between',
          px: 2,
        }}>
          <Box sx={{ width: 40 }} /> {/* Spacer for centering */}
          <Typography variant="h6" sx={{ 
            color: 'white', 
            fontWeight: 'bold', 
            fontFamily: 'Yekan, Vazir', // Rafi project font priority
            textAlign: 'center',
            flex: 1,
          }}>
            پنل مدیریت
          </Typography>
          <IconButton
            onClick={handleDrawerToggle}
            sx={{
              color: 'white',
              background: 'rgba(255, 255, 255, 0.1)',
              '&:hover': {
                background: 'rgba(255, 255, 255, 0.2)',
              },
            }}
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>
        <Box sx={{ overflow: 'auto', pt: 2, fontFamily: 'Vazir' }}>
          <List sx={{ fontFamily: 'Vazir', px: 1 }}>
            {menuItems.map((item) => (
              <ListItem key={item.key} disablePadding sx={{ mb: 0.5, fontFamily: 'Vazir' }}>
                <ListItemButton 
                  selected={location.pathname === `/${item.key}`} 
                  onClick={() => handleMenuClick(item.key)}
                  sx={{
                    borderRadius: 3,
                    mx: 0.5,
                    py: 1.5,
                    background: location.pathname === `/${item.key}` 
                      ? 'rgba(255, 255, 255, 0.2)' 
                      : 'transparent',
                    color: location.pathname === `/${item.key}` ? '#fff' : 'rgba(255, 255, 255, 0.8)',
                    '&:hover': { 
                      background: 'rgba(255, 255, 255, 0.15)', 
                      color: '#fff',
                      transform: 'translateX(-4px)',
                    },
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    direction: 'rtl',
                    textAlign: 'right',
                    fontFamily: 'Yekan, Vazir', // Rafi project font priority
                    transition: 'all 0.3s ease',
                    position: 'relative',
                    '&::before': location.pathname === `/${item.key}` ? {
                      content: '""',
                      position: 'absolute',
                      right: 0,
                      top: '50%',
                      transform: 'translateY(-50%)',
                      width: '4px',
                      height: '60%',
                      background: 'rgba(255, 255, 255, 0.8)',
                      borderRadius: '0 4px 4px 0',
                    } : {},
                  }}
                >
                  <ListItemText
                    primary={item.label}
                    sx={{
                      fontFamily: 'Yekan, Vazir', // Rafi project font priority
                      ml: 3,
                      fontWeight: location.pathname === `/${item.key}` ? 'bold' : '500',
                      fontSize: '1rem',
                      width: '100%',
                      '& .MuiListItemText-primary': {
                        textAlign: 'right', // راست‌چین کردن متن
                        direction: 'rtl',
                      },
                    }}
                  />
                  <Box sx={{ 
                    opacity: location.pathname === `/${item.key}` ? 1 : 0.7,
                    transition: 'opacity 0.3s ease',
                  }}>
                  {item.icon}
                  </Box>
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Box>
      </Drawer>

      {/* Main Content Area */}
      <Box className="admin-main-content" sx={{ 
        flexGrow: 1,
        width: { xs: '100%', md: 'calc(100% - 280px)' },
        marginRight: { xs: 0, md: '280px' },
        marginLeft: 0,
      }}>
        {/* AppBar */}
        <AppBar className="admin-appbar" position="fixed" sx={{ 
          zIndex: (theme) => theme.zIndex.drawer + 1, 
          background: '#ffffff', // سفید
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)', // سایه سفید
          fontFamily: 'Yekan, Vazir', // Rafi project font priority
          backdropFilter: 'blur(10px)',
          borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
          width: { xs: 'calc(100% - 32px)', md: 'calc(100% - 280px - 32px)' }, // عرض با مارجین
          right: { xs: 0, md: '280px' },
          left: 0,
          margin: '16px', // مارجین بیشتر
          borderRadius: '12px', // گوشه‌های گرد
        }}>
          <Toolbar sx={{ py: 1 }}>
            <Typography variant="h6" noWrap component="div" sx={{ 
              flexGrow: 1, 
              fontWeight: 'bold', 
              fontFamily: 'Yekan, Vazir', // Rafi project font priority
              color: '#004d34', // رنگ تیره برای خوانایی روی پس‌زمینه سفید
            }}>
              پنل مدیریت سایت
            </Typography>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ 
                mr: 2, 
                display: { md: 'none' },
                background: 'rgba(0, 77, 52, 0.1)', // پس‌زمینه سبز روشن
                borderRadius: 2,
                p: 1,
                color: '#004d34', // رنگ تیره
                '&:hover': {
                  background: 'rgba(0, 77, 52, 0.2)', // پس‌زمینه سبز تیره‌تر در hover
                  transform: 'scale(1.05)',
                },
                transition: 'all 0.3s ease',
              }}
            >
              <MenuIcon sx={{ fontSize: 28, color: '#004d34' }} />
            </IconButton>
            
            {/* نمایش تعداد پیام‌های نخوانده */}
            {unreadMessagesCount > 0 && (
              <Badge 
                badgeContent={unreadMessagesCount} 
                color="error" 
                sx={{ 
                  ml: 2,
                  '& .MuiBadge-badge': {
                    background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
                    boxShadow: '0 2px 8px rgba(239, 68, 68, 0.4)',
                  }
                }}
              >
                <EmailIcon sx={{ 
                  color: 'white', 
                  fontSize: 24,
                  background: 'rgba(255, 255, 255, 0.1)',
                  borderRadius: '50%',
                  p: 0.5,
                }} />
              </Badge>
            )}
            
            {/* آیکون کاربر با dropdown */}
            <IconButton
              onClick={handleUserMenuOpen}
              sx={{
                background: 'rgba(0, 77, 52, 0.1)',
                color: '#004d34',
                borderRadius: '50%',
                p: 1.5,
                ml: 2,
                '&:hover': {
                  background: 'rgba(0, 77, 52, 0.2)',
                  transform: 'scale(1.05)',
                },
                transition: 'all 0.3s ease',
              }}
            >
              <AccountCircleIcon sx={{ fontSize: 28 }} />
            </IconButton>
            
            {/* Menu dropdown */}
            <Menu
              anchorEl={userMenuAnchor}
              open={Boolean(userMenuAnchor)}
              onClose={handleUserMenuClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              sx={{
                '& .MuiPaper-root': {
                  borderRadius: '12px',
                  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
                  border: '1px solid rgba(0, 0, 0, 0.08)',
                  mt: 1,
                },
              }}
            >
              {/* نام کاربر */}
              <MenuItem disabled sx={{ 
                fontFamily: 'Yekan, Vazir',
                fontWeight: 'bold',
                color: '#004d34',
                opacity: 1,
                '&:hover': {
                  backgroundColor: 'transparent',
                },
              }}>
                <ListItemIcon>
                  <AccountCircleIcon sx={{ color: '#004d34' }} />
                </ListItemIcon>
                <ListItemText 
                  primary={currentUser?.username || 'کاربر'} 
                  sx={{ fontFamily: 'Yekan, Vazir' }}
                />
              </MenuItem>
              
              <Divider />
              
              {/* تغییر رمز عبور */}
              <MenuItem 
                onClick={() => {
                  setChangePasswordOpen(true);
                  handleUserMenuClose();
                }}
                sx={{ 
                  fontFamily: 'Yekan, Vazir',
                  '&:hover': {
                    backgroundColor: 'rgba(0, 77, 52, 0.08)',
                  },
                }}
              >
                <ListItemIcon>
                  <LockIcon sx={{ color: '#004d34' }} />
                </ListItemIcon>
                <ListItemText 
                  primary="تغییر رمز عبور" 
                  sx={{ fontFamily: 'Yekan, Vazir' }}
                />
              </MenuItem>
              
              {/* خروج */}
              <MenuItem 
                onClick={handleLogout}
                sx={{ 
                  fontFamily: 'Yekan, Vazir',
                  color: '#fb977d',
                  '&:hover': {
                    backgroundColor: 'rgba(251, 151, 125, 0.08)',
                  },
                }}
              >
                <ListItemIcon>
                  <LogoutIcon sx={{ color: '#fb977d' }} />
                </ListItemIcon>
                <ListItemText 
                  primary="خروج" 
                  sx={{ fontFamily: 'Yekan, Vazir' }}
                />
              </MenuItem>
            </Menu>
          </Toolbar>
        </AppBar>

        {/* Content */}
        <Box sx={{ 
          p: { xs: 2, md: 4 }, 
          mt: { xs: 7, md: 8 },
          width: '100%',
          maxWidth: '100%',
          overflow: 'hidden',
        }}>
          <Routes>
            <Route path="/" element={location.pathname === '/' && (
              <Box sx={{ 
                background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
                borderRadius: 4, 
                boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)', 
                p: 4, 
                mb: 3,
                border: '1px solid rgba(99, 102, 241, 0.1)',
                position: 'relative',
                overflow: 'hidden',
                '&::before': {
                  content: '""',
                  position: 'absolute',
                  top: 0,
                  right: 0,
                  width: '100px',
                  height: '100px',
                  background: 'linear-gradient(135deg, rgba(99, 102, 241, 0.1) 0%, rgba(139, 92, 246, 0.1) 100%)',
                  borderRadius: '50%',
                  transform: 'translate(30px, -30px)',
                },
                '&::after': {
                  content: '""',
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                  width: '80px',
                  height: '80px',
                  background: 'linear-gradient(135deg, rgba(236, 72, 153, 0.1) 0%, rgba(251, 191, 36, 0.1) 100%)',
                  borderRadius: '50%',
                  transform: 'translate(-20px, 20px)',
                }
              }}>
                <Typography variant="h4" sx={{ 
                  fontFamily: 'Yekan, Vazir', // Rafi project font priority 
                  mb: 2,
                                  background: 'linear-gradient(135deg, #004d34 0%, #004d34 100%)', // Rafi project primary gradient
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                  fontWeight: 'bold',
                  position: 'relative',
                  zIndex: 1,
                }}>
                  خوش آمدید به پنل مدیریت
                </Typography>
                <Typography sx={{ 
                  fontFamily: 'Yekan, Vazir', // Rafi project font priority
                  color: '#64748b',
                  fontSize: '1.1rem',
                  lineHeight: 1.6,
                  position: 'relative',
                  zIndex: 1,
                  mb: 3,
                }}>
                  از منوی سمت راست بخش مورد نظر را انتخاب کنید. تمامی امکانات مدیریت سایت در دسترس شماست.
                </Typography>

                {/* گزارش‌های آماری */}
                <Box sx={{ 
                  display: 'grid', 
                  gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', md: '1fr 1fr 1fr 1fr' },
                  gap: 3,
                  mb: 4,
                  position: 'relative',
                  zIndex: 1,
                }}>
                  {/* کارت آمار پست‌ها */}
                  <Box sx={{
                    background: 'linear-gradient(135deg, #004d34 0%, #004d34 100%)',
                    color: 'white',
                    p: 3,
                    borderRadius: 3,
                    boxShadow: '0 8px 25px rgba(0, 77, 52, 0.3)',
                    textAlign: 'center',
                    transition: 'transform 0.3s ease',
                    '&:hover': {
                      transform: 'translateY(-5px)',
                    },
                  }}>
                    <Typography sx={{ fontSize: '2rem', fontWeight: 'bold', mb: 1 }}>
                      {posts.length}
                    </Typography>
                    <Typography sx={{ fontSize: '0.9rem', opacity: 0.9 }}>
                      تعداد پست‌ها
                    </Typography>
                  </Box>

                  {/* کارت آمار نظرات */}
                  <Box sx={{
                    background: 'linear-gradient(135deg, #46caeb 0%, #46caeb 100%)',
                    color: 'white',
                    p: 3,
                    borderRadius: 3,
                    boxShadow: '0 8px 25px rgba(70, 202, 235, 0.3)',
                    textAlign: 'center',
                    transition: 'transform 0.3s ease',
                    '&:hover': {
                      transform: 'translateY(-5px)',
                    },
                  }}>
                    <Typography sx={{ fontSize: '2rem', fontWeight: 'bold', mb: 1 }}>
                      {comments.length}
                    </Typography>
                    <Typography sx={{ fontSize: '0.9rem', opacity: 0.9 }}>
                      تعداد نظرات
                    </Typography>
                  </Box>

                  {/* کارت آمار پیام‌ها */}
                  <Box sx={{
                    background: 'linear-gradient(135deg, #4bd08b 0%, #4bd08b 100%)',
                    color: 'white',
                    p: 3,
                    borderRadius: 3,
                    boxShadow: '0 8px 25px rgba(75, 208, 139, 0.3)',
                    textAlign: 'center',
                    transition: 'transform 0.3s ease',
                    '&:hover': {
                      transform: 'translateY(-5px)',
                    },
                  }}>
                    <Typography sx={{ fontSize: '2rem', fontWeight: 'bold', mb: 1 }}>
                      {contactMessages.length}
                    </Typography>
                    <Typography sx={{ fontSize: '0.9rem', opacity: 0.9 }}>
                      پیام‌های تماس
                    </Typography>
                  </Box>

                  {/* کارت آمار رسانه */}
                  <Box sx={{
                    background: 'linear-gradient(135deg, #f8c076 0%, #f8c076 100%)',
                    color: 'white',
                    p: 3,
                    borderRadius: 3,
                    boxShadow: '0 8px 25px rgba(248, 192, 118, 0.3)',
                    textAlign: 'center',
                    transition: 'transform 0.3s ease',
                    '&:hover': {
                      transform: 'translateY(-5px)',
                    },
                  }}>
                    <Typography sx={{ fontSize: '2rem', fontWeight: 'bold', mb: 1 }}>
                      {media.length}
                    </Typography>
                    <Typography sx={{ fontSize: '0.9rem', opacity: 0.9 }}>
                      فایل‌های رسانه
                    </Typography>
                  </Box>
                </Box>

                {/* گزارش‌های اخیر */}
                <Box sx={{ 
                  background: 'rgba(255, 255, 255, 0.8)',
                  borderRadius: 3,
                  p: 3,
                  mb: 3,
                  position: 'relative',
                  zIndex: 1,
                }}>
                  <Typography variant="h6" sx={{ 
                    fontFamily: 'Yekan, Vazir',
                    fontWeight: 'bold',
                    mb: 2,
                    color: '#004d34',
                  }}>
                    📊 گزارش‌های اخیر
                  </Typography>
                  
                  <Box sx={{ display: 'grid', gap: 2 }}>
                    {/* آخرین پست‌ها */}
                    <Box sx={{ 
                      display: 'flex', 
                      justifyContent: 'space-between', 
                      alignItems: 'center',
                      p: 2,
                      background: 'rgba(0, 77, 52, 0.05)',
                      borderRadius: 2,
                    }}>
                      <Typography sx={{ fontFamily: 'Yekan, Vazir', fontSize: '0.9rem' }}>
                        آخرین پست منتشر شده
                      </Typography>
                      <Typography sx={{ 
                        fontFamily: 'Yekan, Vazir', 
                        fontSize: '0.8rem', 
                        color: '#64748b',
                        direction: 'ltr',
                      }}>
                        {posts.length > 0 ? new Date(posts[0].createdAt).toLocaleDateString('fa-IR') : 'هیچ پستی وجود ندارد'}
                      </Typography>
                    </Box>

                    {/* پیام‌های نخوانده */}
                    <Box sx={{ 
                      display: 'flex', 
                      justifyContent: 'space-between', 
                      alignItems: 'center',
                      p: 2,
                      background: 'rgba(251, 151, 125, 0.05)',
                      borderRadius: 2,
                    }}>
                      <Typography sx={{ fontFamily: 'Yekan, Vazir', fontSize: '0.9rem' }}>
                        پیام‌های نخوانده
                      </Typography>
                      <Typography sx={{ 
                        fontFamily: 'Yekan, Vazir', 
                        fontSize: '0.8rem', 
                        color: '#fb977d',
                        fontWeight: 'bold',
                      }}>
                        {unreadMessagesCount} پیام
                      </Typography>
                    </Box>

                    {/* وضعیت سیستم */}
                    <Box sx={{ 
                      display: 'flex', 
                      justifyContent: 'space-between', 
                      alignItems: 'center',
                      p: 2,
                      background: 'rgba(75, 208, 139, 0.05)',
                      borderRadius: 2,
                    }}>
                      <Typography sx={{ fontFamily: 'Yekan, Vazir', fontSize: '0.9rem' }}>
                        وضعیت سیستم
                      </Typography>
                      <Typography sx={{ 
                        fontFamily: 'Yekan, Vazir', 
                        fontSize: '0.8rem', 
                        color: '#4bd08b',
                        fontWeight: 'bold',
                      }}>
                        ✅ آنلاین
                      </Typography>
                    </Box>
                  </Box>
                </Box>
                <Box sx={{ 
                  mt: 3, 
                  display: 'flex', 
                  gap: 2, 
                  flexWrap: 'wrap',
                  position: 'relative',
                  zIndex: 1,
                }}>
                  <Box sx={{
                    background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                    color: 'white',
                    px: 3,
                    py: 1.5,
                    borderRadius: 3,
                    fontSize: '0.9rem',
                    fontWeight: 'bold',
                    fontFamily: 'Yekan, Vazir', // Rafi project font priority
                    boxShadow: '0 4px 12px rgba(16, 185, 129, 0.3)',
                  }}>
                    ✅ آماده استفاده
                  </Box>
                  <Box sx={{
                    background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
                    color: 'white',
                    px: 3,
                    py: 1.5,
                    borderRadius: 3,
                    fontSize: '0.9rem',
                    fontWeight: 'bold',
                    fontFamily: 'Yekan, Vazir', // Rafi project font priority
                    boxShadow: '0 4px 12px rgba(59, 130, 246, 0.3)',
                  }}>
                    🚀 عملکرد بالا
                  </Box>
                  <Box sx={{
                    background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
                    color: 'white',
                    px: 3,
                    py: 1.5,
                    borderRadius: 3,
                    fontSize: '0.9rem',
                    fontWeight: 'bold',
                    fontFamily: 'Yekan, Vazir', // Rafi project font priority
                    boxShadow: '0 4px 12px rgba(245, 158, 11, 0.3)',
                  }}>
                    🎨 طراحی مدرن
                  </Box>
                </Box>
              </Box>
            )} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/category" element={<Category />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/media" element={<Media />} />
            <Route path="/social" element={<Social />} />
            <Route path="/custom-pages" element={<CustomPages />} />
            <Route path="/custom-pages/:id" element={<PageEditor />} />
            <Route path="/admin/page-editor/:section" element={<PageEditor />} />
            <Route path="/custom-pages/page-editor/:section" element={<PageEditor />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/testimonial" element={<Testimonial />} />
            <Route path="/landing" element={<Landing />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/comments" element={<Comments />} />
            <Route path="/contact-messages" element={<ContactMessages />} />
            <Route path="/users" element={<Users />} />
          </Routes>
        </Box>
      </Box>

      {/* دیالوگ تغییر رمز عبور */}
      <Dialog open={changePasswordOpen} onClose={handleChangePasswordClose} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ fontFamily: 'Yekan, Vazir', fontWeight: 'bold', color: '#004d34' }}>
          تغییر رمز عبور
        </DialogTitle>
        <form onSubmit={handleChangePasswordSubmit}>
          <DialogContent>
            <TextField
              fullWidth
              label="رمز عبور جدید"
              name="newPassword"
              type="password"
              value={passwordData.newPassword}
              onChange={handlePasswordInputChange}
              required
              helperText="رمز عبور جدید باید حداقل ۶ کاراکتر باشد"
              sx={{ mb: 2, fontFamily: 'Yekan, Vazir' }}
            />
            <TextField
              fullWidth
              label="تایید رمز عبور جدید"
              name="confirmPassword"
              type="password"
              value={passwordData.confirmPassword}
              onChange={handlePasswordInputChange}
              required
              sx={{ fontFamily: 'Yekan, Vazir' }}
            />
          </DialogContent>
          <DialogActions sx={{ p: 3 }}>
            <Button onClick={handleChangePasswordClose} sx={{ fontFamily: 'Yekan, Vazir' }}>
              انصراف
            </Button>
            <Button
              type="submit"
              variant="contained"
              sx={{
                background: 'linear-gradient(135deg, #004d34 0%, #004d34 100%)',
                fontFamily: 'Yekan, Vazir',
                fontWeight: 'bold',
              }}
            >
              تغییر رمز عبور
            </Button>
          </DialogActions>
        </form>
      </Dialog>

      {/* Snackbar برای نمایش پیام‌ها */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar(prev => ({ ...prev, open: false }))}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
      >
        <Alert
          onClose={() => setSnackbar(prev => ({ ...prev, open: false }))}
          severity={snackbar.severity}
          sx={{ fontFamily: 'Yekan, Vazir' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}

export default MainApp; 